module.exports = __webpack_public_path__ + "img/em.9dc2179d.png";